import styled from "styled-components";
import Typography from "@material-ui/core/Typography"
import TableCell from '@material-ui/core/TableCell'


export const HeaderTypo = styled.h3`
    background-color: #33383e !important;
    padding: 0.4rem 0 !important;
    color: #ffffff;
    font-family: "HelveticaNeue" !important;
    font-size: 19px ;
    text-align: center;
    font-weight: 400;
    margin:0;
    margin-bottom: 20px;

    span{
        font-size: 24px !important;
    }
`
export const TableContainer = styled.div`
    overflow-y: auto;
    border-radius: 10px !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
`
export const StyledTableCell = styled.td`
    border-bottom: none !important;
    color: rgb(51, 56, 62);
    font-family: HelveticaNeueBold;
    font-size: 13px !important;
    letter-spacing: 1px;
    padding-left: 2rem;
    padding-right:2rem;

    &.light {
        color: rgba(0, 0, 0, 0.54);
        font-weight: bold;
    }
    &.big {
        font-size: 1.2rem !important;
    }
    &.grow{
        padding-left: 0 !important;
        padding-right:2rem;
    }

`

export const StyledRowCell = styled.tr`
    &.separate {
        color: inherit;
        height: 30px;
        display: table-row;
        outline: none;
        font-size: 16px !important;
        vertical-align: middle;
    }
    &.divider{
        color: inherit;
        height: 10px;
        display: table-row;
        outline: none;
        font-size: 16px !important;
        vertical-align: middle;
    }
`

export const Divider = styled.hr`
  border: 0, 5px solid #33383e;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const StyledLink = styled.a`
    border-bottom: none !important;
    color: rgb(51, 56, 62);
    font-family: HelveticaNeueBold;
    font-size: 13px !important;
    letter-spacing: 2px;
    text-decoration: none;
    padding-right:2rem;

    &.light {
        color: rgba(0, 0, 0, 0.54);
        font-weight: bold;
    }
    &.big {
        font-size: 1.5rem !important;
    }
    &.grow{
        padding-right:0 !important;
    }


`


// WEBPACK FOOTER //
// ./src/components/styles/resumenPayment/styles.js